<template>
  <div
    class="incrediIcon-button"
    :class="{ 'incrediIcon-button--active': active }"
    :style="incrediIconButtonStyle"
    v-bind="$attrs"
  >
    <i
      :class="icon"
      :style="iconStyle"
    />
    <div
      v-if="badgeText !== undefined"
      class="incrediIcon-button--badge row items-center justify-center ibf-h7"
      :style="badgeStyle"
      v-html="badgeText"
    />
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: '40px',
    },
    iconSize: {
      type: String,
      default: '27px',
    },
    badgeWidth: {
      type: String,
      default: '16px',
    },
    badgeHeight: {
      type: String,
      default: '16px',
    },
    borderRadius: {
      type: String,
      default: '50%',
    },
    badgeRight: {
      type: String,
      default: '9%',
    },
    icon: {
      type: String,
      required: false,
    },
    badgeText: {
      type: [String, Number],
    },
    badgeColor: {
      type: String,
      default: 'black',
    },
    iconColor: {
      type: String,
      default: 'black',
    },
  },
  computed: {
    incrediIconButtonStyle() {
      return {
        height: this.size,
        width: this.size,
      };
    },
    iconStyle() {
      return { color: this.iconColor, fontSize: this.iconSize };
    },
    badgeStyle() {
      return {
        height: this.badgeHeight,
        width: this.badgeWidth,
        backgroundColor: this.badgeColor,
        borderRadius: this.borderRadius,
        right: this.badgeRight,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.incrediIcon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.3s ease;
  position: relative;
  &:hover {
    background: #7f878929;
  }
  &:active {
    background: #7f87894d;
  }
}
.incrediIcon-button--active {
  background: #7f87894d;
}
.incrediIcon-button--badge {
  text-align: center;
  position: absolute;
  top: 13%;
  font-size: 11px;
  color: white;
  :deep(& > *) {
    display: flex;
  }
}
</style>
